import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar2022 from 'views/HumanityClub/components/Sidebar2022';
import Sidebar2025 from '../Humanity2023/Sidebar2025';


const SocialStudiesCCAClass3to52025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/socialcca/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/socialcca/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/socialcca/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/socialcca/4.webp`;
   
    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
    ];

    return (
        <Main>

            <Container>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
                                <Typography variant='h5' align='center' >
                               SOCIAL STUDIES CCA
                                </Typography>
                                <br></br>
                                <Typography variant='h7' align='justify' >
                                Class 3: Mass Media: Past vs Present
                                <br></br>
                                Class 4: Epochs of India: Poster/Timeline of ancient Indian dynasties
                                <br></br>
                                Class 5: Sustainable Energy: Model Creation 
                                </Typography>
                                <br></br>
        

                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Classes: 3 to 5           Date:  10, 11 and 12 December 2025 
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                "Love nature and be kind to animals"

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The Social Studies CCA, held during the second week of December 2025, saw active and enthusiastic participation from students of Classes 3 to 5.
                                <br></br>
                               Students of Class 3 confidently presented on the topic ‘Technology has changed the way we communicate and its effects on the society demonstrating both their knowledge and public speaking abilities.
                                <br></br>
                                Students of Class 4 displayed their understanding, sharing interesting facts about the civilisation of ancient Indian dynasties and their prominent rulers presenting along with role play. The unique poster designed in their preliminary round complimented their presentation.
                                <br></br>
                                Students of Class 5 organised an engaging presentation by using the model of sustainable energy resources created during the preliminary rounds. They highlighted upon the change in the climate and its impact on the environment and the role of technology in making the world more sustainable.
                                <br></br>
                                This activity fostered collaborative learning, deepened students' understanding of different cultural and environmental topics and sparked their creativity. The varied approaches taken by each group turned the event into a dynamic celebration of talent and innovation.
                                <br></br>
                                </Typography>
                            </Box>
                            {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “ Birds are powerful symbols of liberty and independence. Children expressing a desire to be unrestricted by typical rules or physical limitations, feeling the joy of "soaring, exploring, freedom and liberation” ”
                                <br />
                            </Typography> */}

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>

                        
                        <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box>
                        {/* <Box marginBottom={4}>
                                    <Archive2023/>
                        </Box> */}
                        <Box marginBottom={4}>
                                    <Sidebar2022/>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Main>


    );
};

export default SocialStudiesCCAClass3to52025;